module.exports = __webpack_public_path__ + "media/images/emblems/Lauterbrunnen-coat_of_arms-39f4f602515b46793a96afedefba8eb5.svg";